import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rw",
  "use": "rw-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rw\">\n<rect width=\"40\" height=\"40\" fill=\"#1D1D1B\" />\n<path d=\"M10.9483 17.5916V16.1612H8V27H11.0869V21.8828C11.0869 19.8077 12.2148 18.8608 13.9165 18.8608C14.1539 18.8608 14.3518 18.881 14.6091 18.9011V16C12.9667 16 11.7003 16.544 10.9483 17.5916Z\" fill=\"white\" />\n<path d=\"M31.2693 16.1612L28.6771 23.4945L26.1443 16.1612H23.5324L20.9204 23.4945L18.4074 16.1612H15.4986L19.3374 27H22.3055L24.779 20.2711L27.1733 27H30.1414L34 16.1612H31.2693Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol